import { render } from "./WizardView.vue?vue&type=template&id=48e2ee16"
import script from "./WizardView.vue?vue&type=script&lang=js"
export * from "./WizardView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__